import { toaster } from "components/ui/toaster";
import constant from "constant";
import { api } from "services/api";
import storage from "./storage";

const currencyFor = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "GBP",
  // trailingZeroDisplay: "stripIfInteger",
});

const utils = {
  formatNum: (v) => parseInt(v || 0, 10),
  formatNumF2: (v) => parseFloat(parseFloat(v || 0).toFixed(2)),

  formatCurrency: (v) => currencyFor.format(v || 0),

  formatAmountForTb: (v, type, cellStyle) => {
    let rounded = Number(v || 0).toFixed(2);

    // if (rounded.length <= 11) {
    //   return rounded;
    // }

    const [intPart, decPart] = rounded.split(".");

    const maxIntLength = 11 - 3;
    const trimmedIntPart = intPart.slice(0, maxIntLength);
    const result = `${trimmedIntPart}.${decPart}`;

    // const sp = result.split("");
    // console.log("sp", sp);

    // const sp2 = [" ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " "];

    // let f = 1;
    // for (let i = 10; i >= 0; i--) {
    //   // console.log("-----", i);

    //   if (sp[sp.length - f]) {
    //     const e = sp[sp.length - f];
    //     // console.log(e);
    //     f = f + 1;

    //   // }

    //   // if (e === 0 || e > 0 || e === '.') {
    //     sp2[i] = e;
    //   } else {
    //     sp2[i] = " ";
    //   }
    // }

    // let mm = sp2.join("");

    // console.log(mm);

    return {
      label: type === "no-symbols" ? result : currencyFor.format(result),
      cellStyle: {
        textStyle: {
          // w: "12ch",
          textAlign: "end",
          ...cellStyle,
        },
      },
    };
  },

  epochToDate: (v) => {
    let d = new Date();

    if (v && utils.validateNum(v)) {
      var utcSeconds = v;
      d = new Date(0);
      d.setUTCSeconds(utcSeconds);

      // d = new Date(parseInt(v) * 1000);
    }

    if (!d?.getDate) {
      d = new Date();
    }

    return d;
  },

  dateToEpoch: (v) => {
    try {
      let d = new Date();
      if (v?.getDate) {
        d = v;
      }
      return Math.floor(d.getTime() / 1000);
    } catch (error) {
      return "";
    }
  },

  dateStrToStr: (v) => {
    let date = new Date(v);

    let dd = date.getDate() > 9 ? "" : "0";
    dd += date.getDate();

    let mm = date.getMonth() + 1 > 9 ? "" : "0";
    mm += date.getMonth() + 1;

    let yy = date.getFullYear().toString().slice(-2);

    date = `${dd}/${mm}/${yy}`;
    return date;
  },

  dateToDateInput: (v, l) => {
    return utils.dateToYYYYMMDD(v);
  },

  dateToYYYYMMDD: (v) => {
    try {
      if (v?.includes && v.includes("T")) {
        const isoString = v;
        const date2 = new Date(isoString);

        const pad = (num) => String(num).padStart(2, "0");

        const formattedDate = `${date2.getFullYear()}-${pad(
          date2.getMonth() + 1
        )}-${pad(date2.getDate())}`;

        return formattedDate;
      }

      let date = new Date();

      if (v && v.getDate) {
        date = v;
      }

      if (v && v.charAt && v.charAt(5) === "-") {
        // mm-dd-yyyy
        // dd-mm-yyyy
        let [mm, dd, yyyy] = v.split("-");
        if (
          !mm ||
          !dd ||
          !yyyy ||
          mm.length > 2 ||
          dd.length > 2 ||
          yyyy.length !== 4
        ) {
          return "";
        }
        return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
      }

      if (v && utils.validateNum(v)) {
        date = utils.epochToDate(v);
      }

      if (v && v?.length === 10 && v.charAt && v.charAt(4) === "-") {
        // yyyy-mm-dd
        return v;
      }

      if (v && v?.length > 9 && v?.includes("-")) {
        date = new Date(v.slice(0, 10).split("-").join("-"));
      }

      // if (!date.getDate && v) {
      //   date = new Date(v);
      // }

      // if (isNaN(date) && v) {
      //   date = new Date();
      //   date.setTime(v);
      // }

      if (!date?.toISOString) {
        date = new Date();
      }

      let dd = date.getDate() > 9 ? "" : "0";
      dd += date.getDate();
      let mm = date.getMonth() + 1 > 9 ? "" : "0";
      mm += date.getMonth() + 1;
      let yyyy = date.getFullYear().toString();
      return (date = `${yyyy}-${mm}-${dd}`);
      // return date.toISOString().split("T")[0];
      // return date.toISOString().slice(0, 10).split("-").join("-");
    } catch (error) {
      return "";
    }
  },

  strToDateTimeStr: (v, l) => {
    if (v?.includes && v.includes("T")) {
      const isoString = v;
      const date2 = new Date(isoString);

      const pad = (num) => String(num).padStart(2, "0");

      const formattedDate = `${date2.getFullYear()}-${pad(
        date2.getMonth() + 1
      )}-${pad(date2.getDate())} ${pad(date2.getHours())}:${pad(
        date2.getMinutes()
      )}:${pad(date2.getSeconds())}`;

      return formattedDate;
    }

    let date = new Date();

    if (v && utils.validateNum(v)) {
      date = utils.epochToDate(v);
    }

    if (v && v.length > 9 && v.includes("-")) {
      date = new Date(v.slice(0, 10).split("-").join("-"));
    }

    // if (!date.getDate && v) {
    //   date = new Date(v);
    // }

    // if (isNaN(date) && v) {
    //   date = new Date();
    //   date.setTime(v);
    // }

    if (!date.toISOString) {
      date = new Date();
    }

    const dateStr = date.toISOString().split("T")[0];
    const time = new Date().toISOString().split("T")[1];
    const timeStr = time.substring ? time.substring(0, 8) : "";

    if (timeStr) {
      return dateStr + " " + timeStr;
    }

    return dateStr;

    // return date.toISOString().slice(0, 10).split("-").join("-");

    // let dd = date.getDate() > 9 ? "" : "0";
    // dd += date.getDate();

    // let mm = date.getMonth() + 1 > 9 ? "" : "0";
    // mm += date.getMonth() + 1;

    // let yyyy = date.getFullYear().toString();

    // date = `${yyyy}-${mm}-${dd}`;
    // return date;
  },

  dateStrToEpoch: (v) => {
    const date = utils.dateToDateInput(v);
    // if (v && v.length > 9 && v.includes("-")) {
    // date = new Date(v);
    // }
    return utils.dateToEpoch(new Date(date));
  },

  epochToDateStr: (v) => {
    let date = new Date();
    if (v) {
      date = new Date(v);
    }
    return this.dateToDateInput(date);
  },

  dateStrToDate: (v) => {
    try {
      if (!v || typeof v !== "string" || !v.includes("-")) {
        return "";
      }
      const parts = v.split("T")[0].split("-");
      if (parts.length !== 3) {
        return "";
      }
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);

      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return "";
      }

      const date = new Date(year, month, day);

      if (isNaN(date.getTime())) {
        return "";
      }

      return date;
    } catch (error) {
      return "";
    }
  },

  formatDate: (date) => {
    const d = new Date(date);
    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();
    return `${day}/${month}/${year}`;
  },

  formatToDDMMYYYY: function (dateInput) {
    let date;

    try {
      // Normalize input to a Date object

      if (dateInput && utils.validateNum(dateInput)) {
        dateInput = parseInt(dateInput, 10);
      }

      if (dateInput instanceof Date) {
        if (isNaN(dateInput.getTime())) return "";
        date = dateInput;
      } else if (typeof dateInput === "number") {
        const millis = dateInput < 1e12 ? dateInput * 1000 : dateInput;
        date = new Date(millis);
        if (isNaN(date.getTime())) return "";
      } else if (typeof dateInput === "string") {
        date = new Date(dateInput);
        if (isNaN(date.getTime())) return "";
      } else {
        return "";
      }

      // Format as mm-dd-yyyy
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const yyyy = date.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    } catch {
      return "";
    }
  },

  yyyymmddToDbSec: function (v) {
    // yyyy-mm-dd or date obj
    // date_genSecForOldSystem

    try {
      if (v && v?.getDate && v?.toISOString) {
        v = v.toISOString().split("T")[0];
      }

      if (v && typeof v === "string" && v?.length > 10) {
        v = utils.dateToYYYYMMDD(v);
      }

      if (
        v &&
        typeof v === "string" &&
        v.length === 10 &&
        v.charAt(4) === "-"
      ) {
        const [yyyy, mm, dd] = v.split("-").map(Number);

        if (
          !Number.isInteger(yyyy) ||
          !Number.isInteger(mm) ||
          !Number.isInteger(dd) ||
          mm < 1 ||
          mm > 12 ||
          dd < 1 ||
          dd > 31
        ) {
          return "";
        }

        const currentdate = new Date();
        const date = new Date(
          Date.UTC(
            yyyy,
            mm - 1,
            dd,
            currentdate.getHours(),
            currentdate.getMinutes(),
            currentdate.getSeconds()
          )
        );
        const unixTimestamp = Math.floor(date.getTime() / 1000);
        // getsec("2025-08-24") // → Returns epoch seconds for 2025-08-24 at current time (in UTC)
        return unixTimestamp + 2082844800;
      }
      return "";
    } catch (error) {
      return "";
    }
  },

  dbSecToYyyymmdd: function (sec) {
    // oldSystemToYyyyMmDd {

    console.log("dbSecToYyyymmdd", typeof sec);

    try {
      sec = parseInt(sec);
      if (typeof sec !== "number" || !isFinite(sec)) {
        console.log("err dbSecToYyyymmdd sec is not number", sec);
        return "";
      }

      const unixTimestamp = sec - 2082844800;

      const date = new Date(unixTimestamp * 1000);

      console.log("dbSecToYyyymmdd date", date);

      // Format to yyyy-mm-dd
      const yyyy = date.getUTCFullYear();
      const mm = String(date.getUTCMonth() + 1).padStart(2, "0");
      const dd = String(date.getUTCDate()).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}`;
    } catch (e) {
      console.log("err", e);

      return "";
    }
  },

  validateEmail: (v) => {
    return String(v)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      ? true
      : false;
  },

  validateNum: (v) => {
    return String(v).toLowerCase().match("^[0-9]+$") ? true : false;
  },

  validateLandlineNum: (v) => {
    if (v) {
      return String(v).toLowerCase().match("^[0-9]+$") ? true : false;
    }
    return false;
  },

  validateMobileNum: (v) => {
    if (v && (v.charAt(0) === 0 || v.charAt(0) === "0") && v.length === 11) {
      return String(v).toLowerCase().match("^[0-9]+$") ? true : false;
    }
    return false;
  },

  validateUserAppCode: (v) => {
    if (v) {
      return String(v).length === 7 ? true : false;
    }
    return false;
  },

  getDealerid: (list) => {
    let res;
    if (list && list[0]) {
      list.forEach((itm) => {
        if (itm.selected) {
          res = itm.data.dealerid;
        }
      });
    }
    return res;
  },

  getCoverid: (list) => {
    let res;
    if (list && list[0]) {
      list.forEach((itm) => {
        if (itm.selected) {
          res = itm.data.coverid;
        }
      });
    }
    return res;
  },

  getDurationid: (list) => {
    let res;
    if (list && list[0]) {
      list.forEach((itm) => {
        if (itm.selected) {
          res = itm.data.durationid;
        }
      });
    }
    return res;
  },

  getLimitId: (list) => {
    let res;
    if (list && list[0]) {
      list.forEach((itm) => {
        if (itm.selected) {
          res = itm.key;
        }
      });
    }
    return res;
  },

  checkTwoDecimalPoints: (value) => {
    if (typeof value === "number") {
      return value % 1 === 0 ? "flash" : value.toFixed(2) === value.toString();
    }

    if (typeof value === "string") {
      const cleanedValue = value.replace(/[^\d.]/g, "").trim();

      const regex = /^\d+\.\d{2}$/;
      return regex.test(cleanedValue);
    }

    return "flash";
  },

  getRegionalManagers: async ({
    setIsLoading,
    onChangeRegManDD,
    action,
    defaultVal,
  }) => {
    setIsLoading(true);
    return api.getCommissionsheetRegMan().then((res) => {
      setIsLoading(false);
      let result = {
        action: action,
        index: undefined,
        item: undefined,
        list: [],
      };
      if (res?.status === 200) {
        console.log("getRegionalManagers = ", res?.data);
        if (res?.data && res?.data[0]?.userid) {
          result.list = res.data.map((a, index) => ({
            key: `reg-man-${index}`,
            value: `${a.companyname}-${index}`,
            label: a.companyname,
            data: a,
          }));

          if (result?.list && result.list[0].key) {
            if (
              action === "useState" &&
              result?.list[0]?.data?.userid &&
              !result?.list[1]?.data?.userid
            ) {
              defaultVal = result?.list[0]?.data?.userid;
            }

            if (action === "useState" && defaultVal) {
              result.list = result?.list?.map((a, index) => {
                if (a.data.userid === defaultVal) {
                  a.selected = true;
                  result.index = index;
                  result.item = a;
                } else {
                  a.selected = false;
                }
                return a;
              });

              if (result?.item?.key && result?.list && result?.list[0]) {
                result.list[0].selected = true;
              } else {
                result.index = 0;
                result.item = result.list[0];
              }
            }
          }

          // onChangeRegManDD(l);
        } else {
          // onChangeRegManDD([]);
        }
      } else {
        // onChangeRegManDD([]);
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
      onChangeRegManDD(result);
    });
  },

  getDealers: async ({
    setIsLoading,
    action,
    onDealersChange,
    allOption,
    defaultVal,
    cb401,
  }) => {
    const allOption2 = allOption === false ? false : true;
    setIsLoading(true);
    return api.getDealers().then(async (res) => {
      console.log("getDealers =", res);
      setIsLoading(false);
      let result = {
        action: action,
        index: undefined,
        item: undefined,
        list: [],
      };
      if (res?.status === 200) {
        if (res?.data && res?.data[0]) {
          result.list = res.data.map((a, index) => ({
            key: `dealer-${index}`,
            value: `${a.companyname}-${index}`,
            label: a.companyname,
            data: { dealerid: a.dealerid },
          }));

          if (result?.list && result.list[0].key) {
            if (allOption2 && result?.list.length > 1) {
              result.list = [
                {
                  key: "dealer-all",
                  value: "all",
                  label: "All",
                  data: { dealerid: -1 },
                },
                ...result?.list,
              ];

              result.list[0].selected = true;
              result.item = result.list[0];
              result.index = 0;
            } else {
              // result.list[0].selected = true;
              // result.item = result.list[0];
              // result.index = 0;
            }

            if (
              action === "useState" &&
              result?.list[0]?.data?.dealerid &&
              !result?.list[1]?.data?.dealerid
            ) {
              defaultVal = result?.list[0]?.data?.dealerid;
            }

            if (action === "useState" && defaultVal) {
              result.list = result?.list?.map((a, index) => {
                if (a.data.dealerid === defaultVal) {
                  a.selected = true;
                  result.index = index;
                  result.item = a;
                } else {
                  a.selected = false;
                }
                return a;
              });

              if (result?.item?.key && result?.list && result?.list[0]) {
                result.list[0].selected = true;
              } else {
                result.index = 0;
                result.item = result.list[0];
              }
            } else {
              // index: 0,
              // list: arr,
              // item: arr[0],
              // onDealersChange(result);
            }
            // setDealers(arr);
          }
          // setDealers(arr);

          // if (action !== "useState") {
          // arr[0].selected = true;
          // setBranchname(arr[0].label);
          // getPolicyTypes({ dealerid: arr[0].data.dealerid });
          // }

          // setBranchname(arr[0].label);
          // getPolicyTypes({ dealerid: itemData.dealerid, action });
          // } else {
          //   onDealersChange({
          //     // index: indx,
          //     // item: item,
          //     list: arr,
          //     // action: action,
          //   });
          //   // setDealers(arr);
          // }
        }
      } else if (res?.status === 401 && cb401?.call) {
        await cb401();
      } else {
        // onDealersChange(result);
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
      onDealersChange(result);
    });
  },

  getSelectDearerid: ({ list, id }) => {
    let list2 = JSON.parse(JSON.stringify(list));
    let index;
    let item;
    if (list2 && list2[0]) {
      list2 = list2.map((a, idx) => {
        if (a?.data?.dealerid === id) {
          a.selected = true;
          item = a;
          index = idx;
        } else {
          a.selected = false;
        }
        return a;
      });
    }

    return {
      index,
      item,
      list: list2,
    };
  },

  getCliamStatusDD: ({ setClaimStatusDD, defaultVal, onChangeClaimStDD }) => {
    console.log("getCliamStatusDD()", defaultVal);
    const claimStatusList = Object.values(constant.claimStateColor);
    // const arr = Array.from(
    //   Object.keys(constant.claimStateColor),
    //   (k) => constant.claimStateColor[`${k}`]
    // );
    // console.log(arr);
    // console.log("claimStatusList", claimStatusList);
    // claimStatusList[0].selected = true;

    let stindex;
    let item;
    const ls = claimStatusList.map((a, index) => {
      const ress = {
        key: `claimstatus-${index}`,
        value: a?.statename + "-" + index,
        label: a?.statename,
        data: a,
        selected: false,
      };

      if (defaultVal && a?.stateid === defaultVal) {
        ress.selected = true;
        item = ress;
        stindex = index;
      }

      return ress;
    });
    console.log("getCliamStatusDD()", ls);
    if (onChangeClaimStDD) {
      onChangeClaimStDD({ index: stindex, list: ls, item });
    }
    if (setClaimStatusDD) {
      setClaimStatusDD(JSON.parse(JSON.stringify(ls)));
    }
  },

  getLimitDD: ({ setFilerLast, defaultVal = 3, onChangeFlLast, action }) => {
    const filLast = [...constant.filterLast];
    let result = {
      action,
      index: 0,
      item: filLast[0],
      list: filLast,
    };

    // if (defaultVal) {

    result.list = filLast.map((a, index) => {
      if (a?.key === defaultVal) {
        // a.selected = true;
        result.index = index;
        result.item = a;
      }
      a.selected = false;
      return a;
    });

    if (result?.list && result.list[result?.index]) {
      result.list[result?.index].selected = true;
    }

    // }

    // if (!result?.item && result?.list && result.list[0]) {

    // result.index = 0;
    // result.item = result.list[0];

    // }

    if (onChangeFlLast) {
      onChangeFlLast(result);
    }

    if (setFilerLast) {
      setFilerLast(result.list);
    }
  },

  getPreTitleDD: ({ action, onChangeTitles, defaultVal }) => {
    const titles = [...constant.personTitles];
    let ind;
    let item;
    let list = titles?.map((a, index) => {
      const res = {
        key: `pre-title-${index}`,
        value: a?.value + "-" + index,
        label: a?.label,
        data: a,
        selected: false,
      };

      if (defaultVal && a?.value === defaultVal) {
        res.selected = true;
        res.data.selected = true;
        ind = index;
        item = res;
      }

      return res;
    });

    onChangeTitles({
      index: ind,
      item: item,
      list: list,
      action: action,
    });
  },

  getCommRuleTypeStr: (id) => {
    let res = "";
    const list = [...constant.defaultCommRuleDD];
    if (list && list[0]) {
      list.forEach((itm) => {
        if (itm.id === id) {
          res = itm.label;
        }
      });
    }
    return res;
  },

  getCommRulePaidTypeStr: (id) => {
    let res = "";
    const list = [...constant.defaultCommRulePaidDD];
    if (list && list[0]) {
      list.forEach((itm) => {
        if (itm.id === id) {
          res = itm.label;
        }
      });
    }
    return res;
  },

  getStateId: function (statename, statetype) {
    let res;
    constant.states.forEach(function (itm) {
      if (statename === itm.statename && statetype === itm.statetype) {
        res = itm.stateid;
        return;
      }
    });
    return res;
  },

  getUserCustomData: ({ userData, key }) => {
    const { userid, usecustomlogo } = userData;

    const ucd = constant.userCustom;
    let data = JSON.parse(JSON.stringify(ucd));
    data = data[userid];

    if (usecustomlogo === true && key && data && data[key]) {
      return data[key];
    }

    data = ucd["-1"];
    if (key && data && data[key]) {
      return data[key];
    }
    return;
  },

  logout: async ({ dispatch, setUserData }) => {
    const res = await api.logout();
    console.log("logout res", res);
    // if (res?.status === 200) {
    storage.clear();
    dispatch(setUserData({}));
    // } else {
    //   toaster.create({
    //     title: res?.message,
    //     type: "error",
    //   });
    // }
  },
};

export default utils;
